import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted } from 'vue';
    import { TargetActions, TargetGetters } from '@/store/modules/target';
    import TargetListTable from '@/components/target/TargetListTable';
    import { useRoute } from 'vue-router';
    import { useStore } from 'vuex';

    
    import { defineComponent } from 'vue';

    const __default__ = defineComponent({
        name: "TargetList",
    });


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

    const route = useRoute();
    const store = useStore();

    const projId = computed(() => route.params.projId);

    onMounted(async () => {
        await store.dispatch(`target/${TargetActions.asyncGetTargetList}`, projId.value);
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TargetListTable)))
}
}

})